import {
  FAILURE_FETCH_X_CSRF_TOKEN,
  REQUEST_FETCH_X_CSRF_TOKEN,
  SET_DEVICE_VARIANT,
  SET_ROOT_PATH,
  SET_X_CSRF_TOKEN,
  SUCCESS_FETCH_X_CSRF_TOKEN,
} from './actionTypes';

export const requestFetchXCSRFToken = () => ({
  type: REQUEST_FETCH_X_CSRF_TOKEN,
});

export const successFetchXCSRFToken = (xCSRFToken: string) => ({
  type: SUCCESS_FETCH_X_CSRF_TOKEN,
  xCSRFToken,
});

export const failureFetchXCSRFToken = () => ({
  type: FAILURE_FETCH_X_CSRF_TOKEN,
});

export const setXCSRFToken = (xCSRFToken: string) => ({
  type: SET_X_CSRF_TOKEN,
  xCSRFToken,
});

export const setRootPath = (rootPath: string) => ({
  type: SET_ROOT_PATH,
  rootPath,
});

export const setDeviceVariant = (userDevice: string) => ({
  type: SET_DEVICE_VARIANT,
  userDevice,
});
